import React, { Fragment,useEffect,useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import StarRatings from "react-star-ratings";
import Moment from "react-moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";
//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";

import { singleOrderDetail } from "../../actions/order";
import { createReview } from "../../actions/review";


  const OrderReview =(props) => {
    const [values,setValues]=useState({
      order: null,
      productId: "",
      show: "hide",
      orderId: "",
      userId: "",
      review: "",
      images: [],
      comment: "",
      reviews: "",
      checkReview: "",
      reviewed: [],
    })
/*   constructor(props) {
    super(props);
    values = {
      order: null,
      productId: "",
      show: "hide",
      orderId: "",
      userId: "",
      review: "",
      images: [],
      comment: "",
      reviews: "",
      checkReview: "",
      reviewed: [],
    };
  } */
  useEffect(async() => {    
    const id = window.location.toString().split("order-review/")[1];
    const order = await props.singleOrderDetail(id);

    if (order) {
      setValues({
        order: order.order,
        orderId: order.order._id,
        userId: order.order.user,
        reviews: order.review,
      });
      var checkReview = [];
      order.review &&
        order.review.forEach((element) => {
          // order.order.items.forEach((elem) => {
          //   if (element.product !== elem.item._id) {

          checkReview.push(element.product);
          // }
          // });
        });
      setValues({ checkReview: checkReview });
      var filteredReview = checkReview.filter(function (v, i, a) {
        return a.indexOf(v) === i;
      });
      setValues({ checkReview: filteredReview });
    }
   },[]);
 /*  async componentDidMount() {
    const id = window.location.toString().split("order-review/")[1];
    const order = await props.singleOrderDetail(id);

    if (order) {
      setValues({
        order: order.order,
        orderId: order.order._id,
        userId: order.order.user,
        reviews: order.review,
      });
      var checkReview = [];
      order.review &&
        order.review.forEach((element) => {
          // order.order.items.forEach((elem) => {
          //   if (element.product !== elem.item._id) {

          checkReview.push(element.product);
          // }
          // });
        });
      setValues({ checkReview: checkReview });
      var filteredReview = checkReview.filter(function (v, i, a) {
        return a.indexOf(v) === i;
      });
      setValues({ checkReview: filteredReview });
    }
  } */
 const handleClose = () => {
    setValues({ ...values,show: "hide", productId: 1 });
  };
 const handleShow = (productId) => {
    setValues({ ...values,show: "show", productId: productId });
  };
 const _openModal = async (e, item) => {
    e.preventDefault();
    setValues({...values, productId: item, show: "show" });
  };
 const changeRating = (newRating, name) => {
    setValues({...values,
      rating: newRating,
    });
  };
 const _submitHandler = async () => {
    const { images, productId, orderId, rating, comment, userId } = values;

    if (values.images.length > 0) {
      let formData = new FormData();

      for (var i = 0; i < images.length; i++) {
        formData.append("images", images[i]);
      }

      formData.append("order", orderId);
      formData.append("user", userId);
      formData.append("product", productId);
      formData.append("review", rating);
      formData.append("feedback", comment);

      setValues({ loading: true });

      const res = await props.createReview(formData);

      setValues({...values, loading: false });

      if (res) {
        setValues({
          loading: false,
          productId: "",
          show: "hide",
          orderId: "",
          userId: "",
          review: "",
          images: [],
          comment: "",
        });
        const id = window.location.toString().split("order-review/")[1];
        const order = await props.singleOrderDetail(id);

        if (order) {
          setValues({...values,
            order: order.order,
            orderId: order.order._id,
            userId: order.order.user,
            reviews: order.review,
          });
          var checkReview = [];
          order.review &&
            order.review.forEach((element) => {
              // order.order.items.forEach((elem) => {
              //   if (element.product !== elem.item._id) {

              checkReview.push(element.product);
              // }
              // });
            });
          setValues({...values, checkReview: checkReview });
        }
        toast(`${res}`, { containerId: "B" });
      }
    } else {
      toast(`Please Select Image`, { containerId: "B" });
    }
  };

 const _handleImageChange=(e)=> {
    e.preventDefault();

    let file = Array.from(e.target.files);

    file.forEach((element, index) => {
      let reader = new FileReader();
      let f = e.target.files[index];

      reader.onloadend = () => {
        setValues({ ...values,images: [...values.images, f] });
      };

      reader.readAsDataURL(f);
    });
  }
  const _setReviewed=(e, item)=> {
    e.preventDefault();
    var newStateArray = values.reviewed.slice();
    newStateArray.push(item);
    setValues({ reviewed: newStateArray });
    // var joined = values.reviewed.concat(item);
    // setValues({ reviewed: values.reviewed.concat(item) });
  }

    const { order, reviews, checkReview } = values;
    return (
      <Fragment>
        <BreadCrumb title={`My Account`} />

        <div className="myorder-wrapper">
          <div className="container-fluid">
            <div className="row">
              <AccountLeftSidebar />
              <div className="col-md-9">
                <div className="myorder-content">
                  <header className="myorder-header">
                    <h3 className="myorder-title">My Orders</h3>
                    <div className="search-order">
                      <div className="order-input-container"></div>
                    </div>
                  </header>
                  <div className="myorder-body">
                    <ul className="nav nav-tabs" id="order-tab" role="tablist">
                      <li className="nav-item">
                        <a
                          className="order-tab-links nav-link active"
                          id="order-tab"
                          data-toggle="tab"
                          href="#order"
                          role="tab"
                          aria-controls="order"
                          aria-selected="true"
                        >
                          Order Details
                        </a>
                      </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="tab-pane fade show active"
                        id="order"
                        role="tabpanel"
                        aria-labelledby="order-tab"
                      >
                        <Fragment>
                          <div className="ordered-item">
                            <div className="ordered-item-header">
                              <div className="ordered-h-columns">
                                <span className="ordered-h-title">
                                  Order Placed
                                </span>
                                <span className="ordered-h-info">
                                  <Moment format="DD/MM/YYYY">
                                    {order && order.createdAt}
                                  </Moment>
                                </span>
                              </div>
                              <div className="ordered-h-columns">
                                <span className="ordered-h-title">Total</span>
                                <span className="ordered-h-info">
                                  ${Number(order && order.amount).toFixed(2)}
                                </span>
                              </div>
                              <div className="ordered-h-columns">
                                <span className="ordered-h-title">
                                  Sundial Order Numebr
                                </span>
                                <span className="ordered-h-info">
                                  {order && order.transactionId}
                                </span>
                              </div>
                              <div className="ordered-h-columns">
                                <span className="ordered-h-title">Status</span>
                                <span className="ordered-h-info order-status">
                                  {order && order.orderStatus}
                                </span>
                              </div>
                            </div>
                            <div className="ordered-help">
                              <Link to={"/customer-service"}>Get Help</Link>
                            </div>
                            <hr />
                          </div>
                          <div className="row">
                            {order &&
                              order.items.length > 0 &&
                              order.items.map((product, ind) => (
                                <div className="col-md-5" key={ind}>
                                  <div className="ordered-product">
                                    <div className="ordered-product-img">
                                      <img
                                        src={
                                          product.item.images &&
                                          product.item.images[0]
                                        }
                                        width="150px"
                                        alt=""
                                      />
                                    </div>
                                    <div
                                      className="ordered-product-details"
                                      style={{ marginLeft: "10px" }}
                                    >
                                      <strong>
                                        <Link
                                          to={`/product/${product.item.slug}`}
                                        >
                                          {product && product.item.title}
                                        </Link>
                                      </strong>
                                      <span className="mt-2">
                                        Model Number: {product.item.modelNumber}
                                      </span>
                                      <span>Quantity: {product.quantity}</span>

                                      {reviews &&
                                        reviews.map((singleReview, ind) =>
                                          singleReview.product ===
                                          product.item._id ? (
                                            checkReview.indexOf(
                                              singleReview.product
                                            ) !== -1 ? (
                                              <span key={ind}>
                                                <StarRatings
                                                  rating={singleReview.review}
                                                  starDimension="15px"
                                                  starSpacing="3px"
                                                  starRatedColor="gold"
                                                />
                                                <p>{singleReview.feedback}</p>
                                                <p>
                                                  {singleReview.images.map(
                                                    (img, ind1) => (
                                                      <img
                                                        key={ind1}
                                                        src={img}
                                                        height="50"
                                                        width="50"
                                                        alt=""
                                                      />
                                                    )
                                                  )}
                                                </p>
                                              </span>
                                            ) : (
                                              <Fragment key={ind}>
                                                {checkReview.indexOf(
                                                  singleReview.product
                                                ) === -1 ? (
                                                  <span
                                                    className=" ordered-h-info order-status"
                                                    style={{ color: "#fff" }}
                                                    onClick={(e) =>
                                                      _openModal(
                                                        e,
                                                        product.item._id
                                                      )
                                                    }
                                                  >
                                                    Add Review{" "}
                                                  </span>
                                                ) : null}
                                              </Fragment>
                                            )
                                          ) : null
                                        )}
                                      {reviews.length === 0 ? (
                                        <span
                                          className=" ordered-h-info order-status"
                                          style={{ color: "#fff" }}
                                          onClick={(e) =>
                                            _openModal(e, product.item._id)
                                          }
                                        >
                                          Add Review
                                        </span>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </Fragment>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal fade ${values.show}`}
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={handleClose}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="review-order-bottom">
                  <div className="review-bottom-content">
                    <div className="review-reviewes">
                      <h4>Reviews</h4>
                      <ul className="review-review-list">
                        <StarRatings
                          rating={values.rating}
                          starRatedColor="gold"
                          changeRating={changeRating}
                          numberOfStars={5}
                          name="rating"
                        />
                      </ul>
                    </div>
                    <div className="review-commint">
                      <h4>Type Your Comment</h4>
                      <textarea
                        cols={35}
                        rows={3}
                        className="review-txt-area"
                        defaultValue={""}
                        onChange={(e) =>
                          setValues({ comment: e.target.value })
                        }
                      />
                    </div>
                    <div className="review-select-file">
                      <h4>Upload File</h4>

                      <input
                        type="file"
                        onChange={(e) => _handleImageChange(e)}
                        multiple
                        className="review-input"
                      />
                    </div>
                    {"(you can select multiple pictures)"}
                  </div>
                  <div className="review-send-btn">
                    <button
                      className="send-review-file"
                      onClick={(e) => _submitHandler(e)}
                    >
                      Send
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }


singleOrderDetail.propTypes = {
  singleOrderDetail: PropTypes.func.isRequired,
};
createReview.prototype = {
  createReview: PropTypes.func.isRequired,
};
export default connect(null, { singleOrderDetail, createReview })(OrderReview);
